export default function EnvelopeIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M7.28949 4.90761C10.4241 4.63513 13.5765 4.63512 16.7111 4.90761L18.2214 5.03889C19.2267 5.12629 20.0878 5.72596 20.534 6.58374C20.591 6.69347 20.5483 6.82633 20.4431 6.89144L14.1771 10.7704C12.8333 11.6023 11.1387 11.6197 9.77802 10.8157L3.4702 7.08833C3.36829 7.02811 3.32151 6.90415 3.36744 6.79505C3.77559 5.82548 4.69322 5.1333 5.77925 5.0389L7.28949 4.90761Z"
                fill="white"
            />
            <path
                d="M3.3623 8.76688C3.20634 8.67472 3.00734 8.7739 2.98916 8.95414C2.73542 11.4698 2.79683 14.0092 3.17339 16.5133C3.3719 17.8334 4.44931 18.8455 5.77926 18.9611L7.28949 19.0924C10.4241 19.3649 13.5765 19.3649 16.7111 19.0924L18.2214 18.9611C19.5513 18.8455 20.6287 17.8334 20.8272 16.5133C21.2148 13.9363 21.2685 11.3217 20.9885 8.73428C20.9688 8.55276 20.7665 8.45541 20.6112 8.55151L14.9667 12.0458C13.1485 13.1713 10.8559 13.1949 9.01493 12.1071L3.3623 8.76688Z"
                fill="white"
            />
        </svg>
    )
}
